import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { View } from 'modules/styled/web';
import { openWebSideNav, closeWebSideNav } from 'modules/navigation/navigation.actions';

const barStyles = {
  width: '100%',
  height: '3px',
  my: '3px',
  bg: 'grey',
};

class MenuIcon extends Component {
  toggleMenu = () => {
    const {
      actions,
      navigation: { sideNavIsOpen },
    } = this.props;
    if (sideNavIsOpen) {
      actions.closeWebSideNav();
    }
    if (!sideNavIsOpen) {
      actions.openWebSideNav();
    }
  };

  render() {
    const {
      mr,
      ml,
      navigation: { screenSize },
    } = this.props;
    if (!screenSize) return null;

    return (
      <View sx={{ mr, ml }}>
        <View
          onClick={this.toggleMenu}
          sx={{
            cursor: 'pointer',
            width: 4,
            m: 0,
            ':hover *': {
              bg: 'black !important',
            },
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <View sx={barStyles} />
          <View sx={barStyles} />
          <View sx={barStyles} />
        </View>
      </View>
    );
  }
}

MenuIcon.propTypes = {
  actions: PropTypes.object,
  navigation: PropTypes.object,
  ml: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  mr: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
};

const mapStateToProps = (state) => ({
  navigation: state.navigation,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      openWebSideNav,
      closeWebSideNav,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuIcon);
